import React from 'react'
import PropTypes from 'prop-types'
import { ContentAdd } from 'material-ui/svg-icons'
import { FlatButton } from 'material-ui'

const AddSliderButton = ({
  forCustomRecalls = false,
  forCustomNoShows = false,
  isDisabled,
  toggleDialog,
}) => (
  <FlatButton
    className="buttonContainer"
    style={{ marginBottom: '5%' }}
    disabled={isDisabled}
    onClick={() =>
      toggleDialog(
        true,
        forCustomRecalls ? 'recall' : forCustomNoShows ? 'custom_no_show' : 'custom pre',
      )
    }
  >
    <div className="buttonContent">
      <ContentAdd />
      <h3 className="buttonText">
        Add Custom {forCustomRecalls ? 'Recall' : forCustomNoShows ? 'Missed Appointment' : 'Appointment'} Reminder
      </h3>
    </div>
  </FlatButton>
)

AddSliderButton.propTypes = {
  forCustomRecalls: PropTypes.bool,
  forCustomNoShows: PropTypes.bool,
  isDisabled: PropTypes.bool,
  toggleDialog: PropTypes.func,
}
export default AddSliderButton



// WEBPACK FOOTER //
// ./src/components/Settings/AddSliderButton.js